import { render, staticRenderFns } from "./slot-machine-horizontal.vue?vue&type=template&id=6783bb21&scoped=true&"
import script from "./slot-machine-horizontal.vue?vue&type=script&lang=js&"
export * from "./slot-machine-horizontal.vue?vue&type=script&lang=js&"
import style0 from "./slot-machine-horizontal.vue?vue&type=style&index=0&id=6783bb21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6783bb21",
  null
  
)

export default component.exports